import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';
import { NavigationReloadService } from '../services/navigation-reload.service'; // Adjust path if needed

@Injectable()
export class CustomRouteReuseStrategy implements RouteReuseStrategy {
  constructor(private navigationReloadService: NavigationReloadService) {}

  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle | null): void {
    // No op
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    return null;
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    if (this.navigationReloadService.shouldForceReload()) {
      return false; // Force reload
    }
    // Default reuse logic
    return future.routeConfig === curr.routeConfig;
  }
} 